"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.genericPropType = genericPropType;
exports.cardSpecsPropType = cardSpecsPropType;
exports.cardSpecPropType = cardSpecPropType;
exports.stateListPropType = stateListPropType;
/**
 * PropType Validators
 */

/**
 * Awesome generic PropType validator
 * - needed for checking connected components passed as props
 * @param  {Object} props         component props
 * @param  {String} propName      propName we're validating
 * @param  {String} componentName the component
 * @return {Error}                a new error or null if there's no error
 */
function genericPropType(props, propName, componentName) {
	if (!props[propName]) {
		return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Validation failed.");
	}
	return null;
}

/**
 * cardSpecs PropType validator
 * @param {Object} props - component props
 * @param {String} propName - propName we're validating (cardSpec)
 * @param {String} componentName - the component
 * @return {Error} - a new error or null if there's no error
 */
function cardSpecsPropType(props, propName, componentName) {
	var cardSpecs = props[propName];
	if (!cardSpecs) {
		return new Error("Required prop `" + propName + "` was not specified in `" + componentName + "`. Please supply the config object you get back consumerweb-card.");
	} else if (!cardSpecs.autodetect) {
		return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Please supply the config object you get back consumerweb-card.");
	}
	return null;
}

/**
 * cardSpec PropType validator
 * @param {Object} props - component props
 * @param {String} propName - propName we're validating (cardSpec)
 * @param {String} componentName - the component
 * @return {Error} - a new error or null if there's no error
 */
function cardSpecPropType(props, propName, componentName) {
	var cardSpec = props[propName];
	if (!cardSpec) {
		return new Error("Required prop `" + propName + "` was not specified in `" + componentName + "`. Please supply the config object you get back consumerweb-card.");
	} else if (!cardSpec.fields || !cardSpec.type) {
		return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Please supply the config object you get back consumerweb-card.");
	}
	return null;
}

/**
 * stateList PropType validator
 * @param {Object} props - component props
 * @param {String} propName - propName we're validating (stateList)
 * @param {String} componentName - the component
 * @return {Error} - a new error or null if there's no error
 */
function stateListPropType(props, propName, componentName) {
	var stateList = props[propName];

	// if we don't get the array of states we're expecting from Griffin, return an error
	if (!stateList) {
		return new Error("Required prop `" + propName + "` was not specified in `" + componentName + "`. Please supply the array you get back from griffin.formatCoarseAddress().");
	} else if (!Array.isArray(stateList) || stateList.length && !stateList[0].$id) {
		return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Please supply the array you get back from griffin.formatCoarseAddress().");
	}
	return null;
}


/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/prop-validators/dist/index.js
 ** module id = 345
 ** module chunks = 6
 **/